import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoAplicacaoItemModel } from '../../model-consultaSeguimento'

export enum ConsultaSeguimentoPergunta04GostaDeSubirEmEnum {
  ESCADAS = 'ESCADAS',
  CADEIRAS = 'CADEIRAS',
  MOVEIS = 'MOVEIS',
  BRINQUEDOS = 'BRINQUEDOS',
}

export interface ConsultaSeguimentoPergunta04Model extends ConsultaSeguimentoAplicacaoItemModel {
  PERGUNTA_04_HEADER?: SimNaoEnum
  PERGUNTA_04_GOSTA_DE_SUBIR_EM?: Record<ConsultaSeguimentoPergunta04GostaDeSubirEmEnum, SimNaoEnum>
}
